export enum PageAction {
  New = `new`,
  Edit = `edit`
}
